<template>
  <div class="card modal-card" :class="{ 'max-width-715': !bailleur}">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">{{ $t('ajoutEditContrat.bailleur.newBailleur.title')}}</h1>
          </div>
        </div>
      </div>
      <div class="card-content section section-logo" v-if="!bailleur">
        <div class="link-box-container">
          <div v-for="bailleur in listeTypeBailleur" :key="bailleur.sousType">
            <div @click="generateBailleur(bailleur.sousType)" class="link-box is-cursor-pointer">
              <div :class="bailleur.classLogo"/>
              <p class="has-text-weight-bold is-size-4 has-text-centered">
                {{ $t(bailleur.title) }}
              </p>
            </div>
          </div>
        </div>
        <div class="buttons mgt-20px">
          <qd-button type="is-light" @click="$parent.close()"
                    class="btn-modal-annuler">
            {{$t('listeJournalEcriture.actions.boutonPopupClose')}}
          </qd-button>
        </div>
      </div>

      <div class="card-content " v-if="bailleur">
        <error-msg-component :messages="messages" class="mgt-20px" :error="error" v-if="error"
                             :title="'addEditBailleur.error.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
        <div class="card-content is-paddingless">
          <p class=" is-italic has-text-icon-more is-size-5">
            {{$t('ajoutEditContrat.bailleur.newBailleur.infoGeneral')}}
          </p>
          <info-generales :bailleur="bailleur" :afficherCode="false"
                          :afficherRole="false"
                          class="mgt-10px">
          </info-generales>
          <p class="mgt-20px is-italic has-text-icon-more is-size-5">
            {{$t('ajoutEditContrat.bailleur.newBailleur.adresse')}}
          </p>
          <b-field :label="$t('ajoutDevis.informations.postalAddress')" class="mgt-20px">
            <adresse :showLibelle="false" :adresse="bailleur.adressePostale"
                     :tableName="TIERS"/>
          </b-field>
        </div>
        <div class="buttons mgt-30px">
          <qd-button type="is-light"
                    class="btn-modal-annuler" @click="$parent.close()">
            {{$t('ajoutEditContrat.bailleur.newBailleur.actions.cancel')}}
          </qd-button>
          <qd-button class="button is-addOrEdit" @click="saveBailleur">
            {{$t('ajoutEditContrat.bailleur.newBailleur.actions.create')}}
          </qd-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import {
  TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
  TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
  TIERS_SOUS_TYPE_BAILLEUR_PRO, TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
} from '@/configuration/tiers/tiersConf';
import infoGenerales from '@/components/baux/bailleur/ajoutEditBailleur/infoGenerales';
import genererClient from '@/services/tiers/genererTiers';
import Adresse from '@/components/general/adresse';
import { insertTiers } from '@/services/tiers/saveTiers';
import messageSucces from '@/services/general/messageSucces';
import validation from '@/services/baux/bailleur/validationBailleur';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import validationGeneral from '@/services/validation/validation';
import { TIERS } from '@/configuration/ville/villeConf';

const Societe = createNamespacedHelpers('societe');

export default {
  name: 'p_quickAddNewBailleur',
  props: {
    nomBailleur: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      TIERS: TIERS,
      bailleur: null,
      error: false,
      messages: [],
      bailleurPro: TIERS_SOUS_TYPE_BAILLEUR_PRO,
      messagesChampsVide: [],
      champsVide: [],
    };
  },
  components: {
    errorMsgComponent,
    Adresse,
    infoGenerales,
  },
  methods: {
    generateBailleur(sousType) {
      const bailleur = genererClient();
      bailleur.type = TIERS_TYPE_FOURNISSEUR;
      bailleur.sousTypes = [{ code: sousType }];
      this.bailleur = bailleur;
      if (!this.isParticulier) this.bailleur.nomCommercial = this.nomBailleur;
      else this.bailleur.nom = this.nomBailleur;
    },
    async saveBailleur() {
      this.error = false;
      this.messages = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        let bailleur = cloneDeep(this.bailleur);
        bailleur.sousTypes = bailleur.sousTypes.map(sousType => sousType.code);
        if (this.isParticulier) bailleur.nomCommercial = nomPrenomGetter(bailleur);
        bailleur.societeId = this.societeActiveId;
        bailleur = await insertTiers(bailleur);
        messageSucces(this.$i18n.t('addEditBailleur.notifications.successCreation'));
        this.$parent.close();
        loadingComponent.close();
        this.$emit('newBailleur', bailleur);
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, null);
          validation(e.response, this.messages);
          this.error = true;
          return;
        }
        throw e;
      }
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    isParticulier() {
      return this.bailleur.sousTypes.find((sousType) => {
        return sousType.code === TIERS_SOUS_TYPE_BAILLEUR_PRIVE;
      });
    },
    listeTypeBailleur() {
      return [
        { classLogo: 'logo__bailleurPro', sousType: TIERS_SOUS_TYPE_BAILLEUR_PRO, title: 'choixSousTypeBailleur.sousTypes.pro' },
        { classLogo: 'logo__bailleurPrive', sousType: TIERS_SOUS_TYPE_BAILLEUR_PRIVE, title: 'choixSousTypeBailleur.sousTypes.prive' },
        { classLogo: 'logo__bailleurConcession', sousType: TIERS_SOUS_TYPE_BAILLEUR_CONCESSION, title: 'choixSousTypeBailleur.sousTypes.concession' },
        { classLogo: 'logo__bailleurPro', sousType: TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE, title: 'choixSousTypeBailleur.sousTypes.administrationEtAssimilee' },
      ];
    },
  },
};
</script>

<style scoped>

</style>
